import { BaseEntity } from "@app/models/rest/base-entity";
import {
  HateoasProjection,
  HateoasResource
} from "@lagoshny/ngx-hateoas-client";

@HateoasResource("systemSearchPresets")
export class SystemSearchPreset extends BaseEntity {
  entityName: string;
  jsonData: string;
  searchName: string;
  owner: string;
  upgraded: boolean;
}

@HateoasProjection(SystemSearchPreset, "list")
export class SystemSearchPresetDetail extends BaseEntity {
  entityName: string;
  searchName: string;
  owner: string;
}
